import api from './api';

// Get all projects
const getProjects = async (queryParams = {}) => {
  const response = await api.get('/projects', { params: queryParams });
  return response;
};

// Get single project
const getProject = async (id) => {
  const response = await api.get(`/projects/${id}`);
  return response;
};

// Create new project
const createProject = async (projectData) => {
  const response = await api.post('/projects', projectData);
  return response;
};

// Update project
const updateProject = async (id, projectData) => {
  const response = await api.put(`/projects/${id}`, projectData);
  return response;
};

// Delete project
const deleteProject = async (id) => {
  const response = await api.delete(`/projects/${id}`);
  return response;
};

// Get projects by organization
const getProjectsByOrganization = async (organizationId) => {
  const response = await api.get('/projects', { 
    params: { organization: organizationId } 
  });
  return response;
};

const projectService = {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  getProjectsByOrganization
};

export default projectService;
